// src/components/auth/ProtectedRoute.js
// Protects routes that require authentication using Auth Utils.
// Enhanced to check for token expiration client-side.

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';

// --- Import Auth Utils ---
// Import the enhanced isAuthenticated helper (checks sessionStorage and expiration)
import { isAuthenticated } from '../../utils/auth';

function ProtectedRoute({ children }) {
  // Use the enhanced isAuthenticated function (checks sessionStorage and expiration)
  const isAuth = isAuthenticated();
  console.log("ProtectedRoute Check: Is Authenticated (incl. expiration)?", isAuth); // Debug log

  if (!isAuth) {
    // If not authenticated (token missing or expired), redirect to the sign-in page
    console.log("Redirecting to /auth/sign-in due to failed auth check.");
    // Replace state allows replacing the current entry in history stack
    return <Navigate to="/auth/sign-in" replace />;
  }

  // If authenticated and token is not expired, render the children
  // (either the AdminLayout or a specific component)
  // Or render the Outlet if this route wraps nested routes directly
  return children ? children : <Outlet />;
}

ProtectedRoute.propTypes = {
 children: PropTypes.node, // Can wrap a single component or use <Outlet /> for nested routes
};


export default ProtectedRoute;
